import React from 'react';
export const FlowFormContext = /*#__PURE__*/React.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  type: 'add',
  data: undefined,
  form: undefined,
  approveForm: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSubmitHandler: () => {}
});